import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/sales-management/sales-invoices`;

export const salesInvoiceRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:invoiceId`,
  debtPayment: `${baseRoute}/debt-payment/:invoiceId`,
  viewPayment: `${baseRoute}/view-payment/:invoiceId`,
  returnGoods: `${baseRoute}/return-goods/:invoiceId`,
} as const;

export type ISalesInvoiceRouteParams = IExtractRouteParamMap<
  typeof salesInvoiceRoutesObj
>;

export const salesInvoicePath = createPaths<
  typeof salesInvoiceRoutesObj,
  ISalesInvoiceRouteParams
>(salesInvoiceRoutesObj);
